import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

export default props => {
  const { btnStyle, btnOptions, text, disabled } = props;

  const ButtonCustomized = withStyles({
    root: {
      boxShadow: 'none',
      textTransform: 'none',
      fontSize: '.8rem',
      color: btnStyle.color,
      padding: '5px',
      border: '1px solid',
      lineHeight: 1.5,
      backgroundColor: btnStyle.backgroundColor,
      borderColor: btnStyle.borderColor,
      minWidth: '124px',
      '&:hover': {
        backgroundColor: btnStyle.hoverBackgroundColor,
        borderColor: btnStyle.hoverBorderColor,
        color: btnStyle.hoverColor,
        boxShadow: 'none'
      },
      '&.Mui-disabled': {
        color: '#c5c5c5'
      }
    }
  })(Button);

  return (
    <ButtonCustomized size={btnOptions.size} disabled={disabled}>
      {text}
    </ButtonCustomized>
  );
};
